import { RadarSpinner } from 'epic-spinners'

export default {
  components: {
    RadarSpinner
  },
  props: {
    size: {
      type: Number,
      default: 200
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/spinner/spinner.js